import React from "react";
import "./product.css";
// import img from /static/media/Firefly_20250108145339-removebg-preview.d88fc5f7bf962ba0d25b.png
const ProductHero = () => {
  return (
    <section className="product-hero">
      <div className="product-hero-content">
        <h1>
          Smart & Reliable <br />
          <span>EV Charging Solutions</span>
        </h1>

        <p>
          Powering the future of electric mobility with advanced AC & DC EV
          chargers designed for homes, businesses, and public charging stations.
        </p>

        <div className="product-hero-buttons">
          <button className="product-hero-btn-green">Explore Products</button>
          <button
            className="product-hero-btn-outline"
            onClick={() => window.location.href = "tel:+918012523333"}
          >
            Enquire Now
          </button>
        </div>
      </div>

      <div className="product-hero-image">
        <img
          src="/static/media/Firefly_20250108145339-removebg-preview.d88fc5f7bf962ba0d25b.png"
          alt="EV Charger"
        />
      </div>
    </section>
  );
};

export default ProductHero;
